import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { DUTY_LAWYER_USERNAME } from "@/constants/roles";
import { log } from "@/lib/log";
import { consumeLoginAttempt, reloginUrl } from "@/lib/login-attempts";

export const Route = createFileRoute("/_auth-init-space/_authorized")({
  component: AuthorizedLayout,

  beforeLoad: async ({ context, location }) => {
    if (!context.auth.userStore.state) {
      const tryRelogin = consumeLoginAttempt();
      if (!tryRelogin) {
        log.error("Login attempt limit exceeded. Redirecting to login portal without relogin.");
      }
      throw redirect({
        href: reloginUrl(tryRelogin),
      });
    }

    // Duty lawyers are confined to the legal queue, but may still open an
    // individual story (read-only) — e.g. from a legal-queue link. Bounce them
    // to /legal from everywhere else, including the stories list.
    const isStoryEditor = /^\/stories\/[^/]+/.test(location.pathname);
    if (
      context.auth.userStore.state.username === DUTY_LAWYER_USERNAME &&
      !location.pathname.startsWith("/legal") &&
      !isStoryEditor
    ) {
      throw redirect({ to: "/legal" });
    }
  },
});

function AuthorizedLayout() {
  return (
    <div className="flex flex-col min-h-dvh">
      <Outlet />
    </div>
  );
}
